module.exports = __webpack_public_path__ + "img/feature_buy_en.f6c75f28.png";